<template>
  <vxe-modal
    ref="xModal"
    v-model="formVisible"
    :title="'需求登记' + modalType"
    width="90%"
    height="90%"
    @zoom="zoomWindow"
    @show="showModal"
    :before-hide-method="beforeHideModal"
    @close="closeModal"
  >
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
      <!-- 第一行 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="模块" prop="groupName">
            <el-select
              clearable
              v-model="form.groupName"
              :disabled="!!form.vuePath"
              :placeholder="placeholderConfig.select"
            >
              <!-- @change="groupNameChange" -->
              <el-option
                v-for="(i, index) of ComBoxItems.groupName"
                :key="i + index + ''"
                :label="i"
                :value="i"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="菜单" prop="vuePath">
            <el-select
              clearable
              v-model="form.vuePath"
              @change="vuePathChange"
              :placeholder="placeholderConfig.select"
              :disabled="ifHasDetail"
              filterable
            >
              <el-option
                v-for="(i, index) of ComBoxItems.vuePath"
                :key="i.vuePath + index + ''"
                :label="i.vuePath"
                :value="i.vuePath"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计更新版本" prop="planIssuedVersion">
            <el-input
              v-model="form.planIssuedVersion"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              disabled
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实际更新版本" prop="actualIssuedVersion">
            <el-input
              v-model="form.actualIssuedVersion"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              disabled
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <YKDivider>数据列表</YKDivider>
    <vxe-toolbar>
      <template #buttons>
        <vxe-button size="mini" :disabled="!form.vuePath || !!form.planIssuedVersion" @click="insertOne"
          >新增明细</vxe-button
        >
      </template>
    </vxe-toolbar>
    <!-- :scroll-y="{ enabled: false }" -->
    <vxe-table
      border
      resizable
      keep-source
      ref="xTable"
      :scroll-y="{
        mode: 'wheel'
      }"
      :cell-style="cellStyle"
      :height="tableHeight"
      :show-overflow="false"
      highlight-hover-row
      highlight-current-row
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :mouse-config="{ area: true, extension: true }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod
      }"
      :tree-config="{
        transform: true,
        rowField: 'pid',
        parentField: 'parentID'
      }"
      :data="form.detailList"
      :clip-config="{
        beforePasteMethod: beforePasteMethod,
        pasteMethod: pasteMethod,
        copyMethod: copyMethod,
        afterPasteMethod: afterPasteMethod
      }"
      @cell-dblclick="cellDblclick"
      @cell-menu="cellContextMenuEvent"
      :menu-config="{
        body: { options: bodyMenus },
        visibleMethod: visibleMethod
      }"
      @menu-click="contextMenuClickEvent"
    >
      <vxe-column type="seq" width="40px" fixed="left"></vxe-column>
      <!-- <vxe-column type="checkbox" width="40px" fixed="left"> </vxe-column> -->
      <vxe-column field="delete" title="删除" fixed="left" width="50" align="center">
        <template slot-scope="scope" v-if="scope.row.pid === 0">
          <i
            v-if="scope.row.userCompany === myUserCompany && !scope.row.handleResult"
            :id="'vxeDelete'"
            @click="removeRowForTable(scope.row, $refs.xTable, $data)"
            class="el-icon-delete-solid"
          ></i>
          <i v-else :id="'vxeDeleteDisabled'" class="el-icon-delete-solid"></i>
        </template>
      </vxe-column>
      <!-- <vxe-column
        width="50px"
        fixed="left"
        title="状态"
        v-if="
          myUserClass === '运维' ||
          myUserClass === '管理'
        "
        field="detailState"
      ></vxe-column> -->
      <vxe-column width="240px" fixed="left" field="registrationInformationGroup" title="登记信息" tree-node>
        <template #default="{ row }">
          <div class="label-ellipsis" v-if="row.pid > 0">
            {{ row.userCompany }}
          </div>
          <div class="label-ellipsis">{{ row.recorder }}</div>
          <div class="label-ellipsis">
            {{ ykDateFormat('yyyy-MM-dd', row.recordDate) }}
          </div>
        </template>
      </vxe-column>
      <vxe-column width="50%" field="requirementDesc" title="需求描述" :edit-render="{ name: 'input' }"></vxe-column>
      <vxe-column
        width="240px"
        field="suggestedSolutions"
        title="建议解决方案"
        :edit-render="{ name: 'input' }"
      ></vxe-column>
      <vxe-column field="processingInformationGroup" title="处理信息" min-width="100px">
        <template #default="{ row }">
          <div class="label-ellipsis">{{ row.handler }} {{ row.handleResult }}</div>
          <!-- <div class="label-ellipsis">{{ row.handler }}</div> -->
          <div class="label-ellipsis" v-if="row.pid === 0 && row.handleNote">说明: {{ row.handleNote }}</div>
          <div class="label-ellipsis">
            {{ ykDateFormat('yyyy-MM-dd', row.handleTime) }}
          </div>
        </template>
      </vxe-column>
      <vxe-column field="assessmentInformationGroup" title="评价信息" min-width="100px">
        <template #default="{ row }">
          <div class="label-ellipsis">{{ row.assessResult }}</div>
          <div class="label-ellipsis" v-if="row.pid === 0 && row.assessNote">说明: {{ row.assessNote }}</div>
        </template>
      </vxe-column>
      <vxe-column title="附件" width="100px">
        <template #default="{ row }">
          <div v-if="!row.pid" style="display: flex; justify-content: center">
            <el-link
              style="margin-right: 5px"
              :disabled="
                !!row.handleResult ||
                !row.id ||
                (row.userCompany !== myUserCompany && !['管理', '运维'].includes(myUserClass))
              "
              @click="handleAttachmentUpload(row)"
              type="primary"
              >上传</el-link
            >
            <!-- !row.fileURL || -->
            <!-- 我们公司也要看附件 -->
            <el-link
              :disabled="
                !row.id ||
                (row.userCompany !== myUserCompany &&
                  myUserCompany !== '福州远控' &&
                  !['管理', '运维'].includes(myUserClass)) ||
                !row.isAtachment
              "
              @click="handleAttachment(row)"
              type="primary"
              >查看</el-link
            >
          </div>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- 间隔槽（内含保存按钮） -->
    <div class="buttonContainer">
      <el-button type="primary" :disabled="!!form.planIssuedVersion" @click="save">保存</el-button>
      <el-button type="danger" v-if="id > 0 && onlyMyCompany && !form.planIssuedVersion" @click="del">删除</el-button>
    </div>
    <!-- 明细修改模态窗 -->
    <DetailUpdateModal ref="DetailUpdateModal" :isDisabled="isDisabledToDetail" :updateRow.sync="updateRow" />
    <!-- 处理模态窗 -->
    <AcceptModal ref="AcceptModal" @sureHandler="AcceptSureBack" />
    <!-- 评价模态窗 -->
    <AssessModal ref="AssessModal" @sureHandler="AssessSureBack" />
    <!-- 附件模态窗 -->
    <AttachmentModal
      ref="AttachmentModal"
      :cacheRow="AttachmentCacheRow"
      :files.sync="AttachmentFiles"
      :parentObj="this"
    />
    <!-- 生成图片进度框 -->
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>
    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
  </vxe-modal>
</template>
<script>
import AcceptModal from './AcceptModal'
import AssessModal from './AssessModal.vue'
import DetailUpdateModal from './DetailUpdateModal.vue'
import AttachmentModal from './AttachmentModal'
import { BASEURL } from '@/axios/baseUrlConfig.js'
export default {
  components: {
    DetailUpdateModal,
    AcceptModal,
    AssessModal,
    AttachmentModal
  },
  props: {
    modalType: {
      type: String,
      default: '新增'
    },
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            see: false,
            edit: false
          }
        }
      }
    },
    updateId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      id: 0,
      formVisible: false,
      form: {
        id: 0,
        productionType: '',
        groupName: '',
        vuePath: '',
        planIssuedVersion: '',
        actualIssuedVersion: '',
        detailList: []
      },
      // 主表验证规则
      rules: {},
      // 明细验证规则
      validRules: {},
      // 明细验证错误
      errIndex: [],
      bodyMenus: [
        [
          {
            code: 'handleAssess',
            name: '评价'
          },
          {
            code: 'handleAcceptOn',
            name: '处理'
          },
          {
            code: 'handleAcceptOff',
            name: '取消处理'
          },
          {
            code: 'handleInvalidOn',
            name: '作废'
          },
          {
            code: 'handleInvalidOff',
            name: '取消作废'
          }
        ]
      ],
      // 高度百分百比
      zoomHeightRatio: 0.9,
      // 是否修改过
      IfExistModify: false,
      IfDataBindComplete: false,
      // 下拉框
      ComBoxItems: {
        AllItems: [],
        groupName: [],
        vuePath: []
      },
      // 如果有明细(用于禁用主表菜单选择框)
      ifHasDetail: false,
      // 需要更新的行(缓存)
      updateRow: null,
      // 右击处理id列表
      cellIdList: [],
      // 当前账户的用户类型
      myUserClass: this.$store.state.userInfo.gangWei,
      // 当前账户所在单位
      myUserCompany: this.$store.state.userInfo.company,
      // 需要上传文件的明细id
      uploadFileDetailId: 0,
      // 上传信息
      arrayUpload: [],
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 进度百分比
      percentage: 0,
      // 当前显示进度字符串
      processStr: '',
      // 是否显示进度
      showProress: false,
      // 附件列表
      AttachmentFiles: [],
      // 查看附件的明细
      AttachmentCacheRow: {},
      // 粘贴区域数组
      pasteAreaList: [],
      // 查看需求描述/建议解决方案时是否禁用输入
      isDisabledToDetail: true
    }
  },
  created() {},
  methods: {
    // 日志调用接口方法, 写入日志需要主表信息，不想一个一个写
    async needLogHttpApi(url, body) {
      const res = await this.$http.put(url, {
        ...body,
        productionType: this.form.productionType,
        groupName: this.form.groupName,
        vuePath: this.form.vuePath
      })
      return res
    },
    // 作废及取消作废
    async handleInvalid(type) {
      if (type === 'on') {
        const { data: res } = await this.needLogHttpApi('/Bugs/YKBug/handle', {
          idList: this.cellIdList,
          handleResult: '作废'
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.getBoth(this.id)
        this.parentData['list']()
      } else if (type === 'off') {
        const { data: res } = await this.needLogHttpApi('/Bugs/YKBug/unhandle', {
          idList: this.cellIdList,
          handleResult: '作废'
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.getBoth(this.id)
        this.parentData['list']()
      }
    },
    // 评价回调
    async AssessSureBack({ assessResult, assessNote }) {
      const { data: res } = await this.$http.put('/Bugs/YKBug/assess', {
        idList: this.cellIdList,
        assessResult: assessResult,
        assessNote: assessNote
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getBoth(this.id)
      this.parentData['list']()
    },
    // 处理结果设置回调
    async AcceptSureBack({ handleResult, handleNote }) {
      const { data: res } = await this.needLogHttpApi('/Bugs/YKBug/handle', {
        idList: this.cellIdList,
        handleResult: handleResult,
        handleNote: handleNote
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getBoth(this.id)
      this.parentData['list']()
    },
    // 取消处理
    async handleAcceptOff() {
      const { data: res } = await this.needLogHttpApi('/Bugs/YKBug/unhandle', {
        idList: this.cellIdList,
        handleResult: '取消',
        handleNote: ''
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getBoth(this.id)
      this.parentData['list']()
    },
    // 开启窗口时
    async showModal() {
      this.setFormVaild()
      await this.BindComBox()
      this.InitRight()
      this.IfDataBindComplete = false
      // 公司树节点的PID
      // let pid = -999
      if (this.modalType === '新增') {
        this.id = 0
        this.form = {
          id: 0,
          productionType: this.$store.state.productType,
          groupName: '',
          vuePath: '',
          detailList: []
        }
        this.ifHasDetail = false
      } else if (this.modalType === '修改') {
        this.id = this.updateId
        await this.getBoth(this.id)
      }
      // 是否显示删除列
      this.$refs.xTable.resetColumn()
      const columns = this.$refs.xTable.getTableColumn().fullColumn
      for (let column of columns) {
        if (['delete'].includes(column.property)) {
          this.form.planIssuedVersion ? (column.visible = false) : (column.visible = true)
          break
        }
      }
      this.$refs.xTable.refreshColumn()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // 当模块菜单变化时
    groupNameChange() {
      if (this.form.groupName) {
        this.ComBoxItems.vuePath = this.ComBoxItems.AllItems.filter(item => {
          return item.groupName === this.form.groupName
        })
      } else {
        this.ComBoxItems.vuePath = this.ComBoxItems.AllItems
      }
    },
    // 获取是否能够新增需求
    async getIfCanAdd() {
      const { data: res } = await this.$http.post('/Bugs/YKBug/is-can-add', {
        productionType: this.form.productionType,
        groupName: this.form.groupName,
        vuePath: this.form.vuePath
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 当菜单变化时 (预留)
    async vuePathChange(e) {
      if (!this.form.vuePath) {
        return
      }
      // 根据菜单查找模块
      if (!this.form.groupName) {
        for (let item of this.ComBoxItems.AllItems) {
          if (item.vuePath === e) {
            this.form.groupName = item.groupName
            break
          }
        }
      }
      // 获取是否有别的厂家提的，如果有跳转过去
      const { data: res } = await this.$http.get('/Bugs/YKBug/history', {
        params: {
          productionType: this.$store.state.productType,
          groupName: this.form.groupName,
          vuePath: this.form.vuePath
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      if (res.data > 0) {
        this.id = res.data
        this.$emit('updateModalType', '修改')
        this.getBoth(res.data)
      } else {
        // 如果没有历史数据，则进行判断
        // 在此做是否多少日内不能再提
        const ifCanAdd = await this.getIfCanAdd()
        if (!ifCanAdd) {
          this.form.vuePath = '' // 清空vuepath 不让他操作
        }
      }
    },
    // 插入明细
    async insertOne() {
      let that = this
      // 插入前判断是否可以插入
      const ifCanAdd = await this.getIfCanAdd()
      if (!ifCanAdd) {
        return
      }
      // 定义缓存的父级id、最大的PID(用于新增组)
      let pid = -999
      let maxPID = -999
      // 遍历当前列表
      for (let row of this.$refs.xTable.getTableData().fullData) {
        // 如果单位相同且当前PID未赋值时赋值父级PID
        if (row.userCompany === this.myUserCompany && pid < 0 && row.children.length > 0) {
          pid = row.pid
        }
        // 寻找PID最大值
        if (Number(row.pid) > maxPID) {
          maxPID = Number(row.pid)
        }
      }
      // 遍历新增列表
      for (let row of this.$refs.xTable.getInsertRecords()) {
        if (row.userCompany === this.myUserCompany && pid < 0 && row.parentID === -1) {
          pid = row.pid
        }
        if (Number(row.pid) > maxPID) {
          maxPID = Number(row.pid)
        }
      }
      // 如果含有当前单位的父级时在该组后插入
      if (pid > 0) {
        this.$refs.xTable.insertAt(
          {
            pid: 0,
            parentID: pid,
            userCompany: this.myUserCompany,
            detailState: '正常',
            // requirementDesc: '',
            // suggestedSolutions: '',
            recorder: this.$store.state.userInfo.userName,
            recorderID: this.$store.state.userInfo.userId,
            recordDate: this.ykDateFormat('yyyy-MM-dd', new Date())
          },
          -1
        )
        // 否则新建组，在进行插入
      } else {
        // 如果表中没有pid则把新增的行pid置为1
        maxPID < 0 && (maxPID = 1)
        this.$refs.xTable.insertAt(
          [
            {
              pid: maxPID + 1,
              parentID: -1,
              userCompany: this.myUserCompany,
              detailState: ''
            },
            {
              pid: 0,
              parentID: maxPID + 1,
              userCompany: this.myUserCompany,
              detailState: '正常',
              // requirementDesc: '',
              // suggestedSolutions: '',
              recorder: that.$store.state.userInfo.userName,
              recorderID: this.$store.state.userInfo.userId,
              recordDate: that.ykDateFormat('yyyy-MM-dd', new Date())
            }
          ],
          -1
        )
        this.ifHasDetail = true
      }
      // 处理完后，要自动展开树节点
      this.$nextTick(() => {
        let cacheRow = null
        // 遍历当前列表
        for (let row of this.$refs.xTable.getTableData().fullData) {
          if (row.userCompany === this.myUserCompany && row.parentID === -1) {
            cacheRow = row
            break
          }
        }
        for (let row of that.$refs.xTable.getInsertRecords()) {
          if (row.userCompany === this.myUserCompany && row.parentID === -1) {
            cacheRow = row
            break
          }
        }
        if (cacheRow) {
          that.$refs.xTable.setTreeExpand(cacheRow, true)
        }
      })
      this.IfExistModify = true
    },
    // 删除明细
    // table 点击删除列
    removeRowForTable(row, table, data) {
      this.$messagebox
        .confirm('确定要删除本行吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          // 缓存删除的行父级ID及父级行
          const beforeParentID = row.parentID
          // let parentRow = null
          // 删除本行
          table.remove(row)
          // 每次删除明细后查看父节点是否还存在子节点，若没有子节点则删除父节点
          // 过滤出父级行且查看是否还存在子行
          for (let item of table.getInsertRecords()) {
            if (beforeParentID === item.pid && item.children.length === 0) {
              table.remove(item)
              break
            }
          }
          const tableData = table.getTableData().fullData
          for (let i = tableData.length - 1; i >= 0; i--) {
            // beforeParentID === tableData[i].pid &&
            if (tableData[i].parentID === -1 && tableData[i].children.length === 0) {
              // 删除父节点
              table.remove(tableData[i]) // 树节点有bug 虽然界面上消失了 但是fulldata还是会出现所以需要splice删除数组中的明细
              tableData.splice(i, 1)
              break
            }
          }
          tableData.length > 0 || table.getInsertRecords().length > 0
            ? (this.ifHasDetail = true)
            : (this.ifHasDetail = false)
          // 不存在的话删除父级行
          // !haveChildren && table.remove(parentRow)
          if (data) {
            data.IfExistModify = true
          }
        })
        .catch(() => {})
    },
    // 生成guid
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }

      return guid
    },
    // 附件上传
    handleAttachmentUpload(row) {
      if (!row.id) {
        this.$message.error('上传失败！请保存后重试')
        return
      }
      this.uploadFileDetailId = row.id
      this.$refs.uploadExcel.click()
    },
    /**
     * 上传
     */
    async uploadFile(event) {
      let that = this
      if (this.uploadFileDetailId) {
        that.fileCount = event.target.files.length
        if (that.fileCount === 0) {
          return
        }
        that.completeList = []
        that.arrayUpload = []
        that.percentage = 0
        that.processStr = `${that.percentage}%`
        for (let fileObj of event.target.files) {
          that.uploadSingle(fileObj)
        }
      }
      event.target.value = ''
    },
    // 上传一个文件
    uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      // todo 加入了vuepath参数，是不是区分文件夹？ 先不管 固定了再说
      formData.append('vuePathName', 'RequirementsGather')
      // formData.append('vuePathName', this.vuePathName)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data', 'accept-language': 'zh-CN', 'loading': false },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      that.arrayUpload.forEach(item => {
        if (item.timer) {
          clearInterval(item.timer)
        }
      })
      that.completeList.forEach(item => {
        item.aKeyValue = this.uploadFileDetailId
      })
      const { data: res } = await that.$http.post(`/Base/BAttachment/bulk-insert/`, that.completeList)
      if (res.isSuccess) {
        that.$message.success('上传成功')
        // that.opened()
        that.getBoth(this.id)
      } else {
        that.$message.error(res.errorMessage)
      }
      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    // 计算总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = sumPre / that.fileCount
      that.processStr = `${that.percentage}%`
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    // 点击附件动作
    async handleAttachment(row, type = 'see') {
      if (!row.id) {
        this.$message.error('查看失败！请保存后重试')
        return
      }
      this.AttachmentCacheRow = row
      const { data: res } = await this.$http.post('/Base/BAttachment', {
        vuePath: 'RequirementsGather',
        keyValue: row.id
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      if (res.data.length === 0) {
        if (type === 'see') {
          this.$message.error('该明细未上传附件!')
        }
        this.$refs.AttachmentModal.formVisible = false
        return
      }
      this.AttachmentFiles = res.data
      this.$refs.AttachmentModal.formVisible = true
    },
    // 动态样式
    cellStyle({ row, column }) {
      if (
        row.handleResult === '作废' &&
        (column.property === 'requirementDesc' || column.property === 'suggestedSolutions')
      ) {
        return { background: '#ff8b8b', color: '#fff' }
      }
      // switch (column.property) {
      //   case 'detailState':
      //     return row.detailState === '作废' ? { color: 'red' } : ''
      // }
    },
    // 重写复制前的方法
    copyMethod({ row, column, cellValue }) {
      switch (column.property) {
        // 登记信息 => 因为登记信息是组合的字段，所以复制时需要拼接起来
        case 'registrationInformationGroup':
          return (
            row['userCompany'] +
            (row['recorder'] ? ' ' + row['recorder'] : '') +
            (row['recordDate'] ? ' ' + row['recordDate'] : '')
          )
        // 处理信息 => 同登记信息
        case 'processingInformationGroup':
          return (
            row['handler'] +
            (row['handleResult'] ? ' ' + row['handleResult'] : '') +
            (row['handleNote'] ? ' ' + row['handleNote'] : '') +
            (row['handleTime'] ? ' ' + row['handleTime'] : '')
          )
        // 评价信息 => 同登记信息
        case 'assessmentInformationGroup':
          return row['assessResult'] + (row['assessNote'] ? ' ' + row['assessNote'] : '')
        default:
          return cellValue
      }
    },
    beforePasteMethod() {
      this.pasteAreaList = []
    },
    // 粘贴方法
    pasteMethod({ row, column, cellValue }) {
      switch (column.property) {
        case 'requirementDesc':
        case 'suggestedSolutions':
          if (
            row['pid'] + '' === '0' &&
            (row['userCompany'] === this.myUserCompany || ['管理', '运维'].includes(this.myUserClass)) &&
            !this.form.planIssuedVersion &&
            !row['handleResult']
          ) {
            // 控制管理员或运维只能编辑别的厂家的建议解决方案 ==> 如果 [不为本厂数据 且 是管理员或运维 且 编辑的列不为建议解决方案时] 不执行后续操作
            if (
              row['userCompany'] !== this.myUserCompany &&
              ['管理', '运维'].includes(this.myUserClass) &&
              column.property !== 'suggestedSolutions'
            ) {
              return
            }
            row[column.property] = cellValue
            // 粘贴成功代表修改过数据了
            this.IfExistModify = true
            if (
              this.pasteAreaList.length > 0 &&
              this.pasteAreaList[this.pasteAreaList.length - 1]['endRow']['_XID'] !== row['_XID']
            ) {
              this.pasteAreaList[this.pasteAreaList.length - 1]['endRow'] = row
            }
            if (
              this.pasteAreaList.length > 0 &&
              this.pasteAreaList[this.pasteAreaList.length - 1]['endColumn']['property'] !== column['property']
            ) {
              this.pasteAreaList[this.pasteAreaList.length - 1]['endColumn'] = column
            }
            if (this.pasteAreaList.length === 0) {
              this.pasteAreaList.push({ startRow: row, endRow: row, startColumn: column, endColumn: column })
            }
          }
          break
      }
    },
    // 粘贴后
    afterPasteMethod() {
      this.$nextTick(() => {
        this.$refs.xTable.clearCopyCellArea()
        this.$refs.xTable.setCellAreas(this.pasteAreaList)
      })
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
      this.cellIdList = []
      // if (this.myUserClass === '客户') {
      //   for (let area of this.areas) {
      //     for (let row of area.rows) {
      //       if (row.pid <= 0 && !this.cellIdList.includes(row.id) && row.userCompany === this.myUserCompany) {
      //         this.cellIdList.push(row.id)
      //       }
      //     }
      //   }
      // } else {
      //   for (let area of this.areas) {
      //     for (let row of area.rows) {
      //       if (row.pid <= 0 && !this.cellIdList.includes(row.id)) {
      //         this.cellIdList.push(row.id)
      //       }
      //     }
      //   }
      // }
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            switch (item.code) {
              case 'handleAssess':
                item.disabled = !this.form.planIssuedVersion
                item.visible = true
                break
              case 'handleAcceptOn':
              case 'handleAcceptOff':
                item.disabled = this.form.planIssuedVersion
                if (this.myUserClass === '客户') {
                  item.visible = false
                } else {
                  item.visible = true
                }
                break
              case 'handleInvalidOn':
                if (this.myUserClass === '管理') {
                  item.visible = true
                } else {
                  item.visible = false
                }
                break
              case 'handleInvalidOff':
                item.disabled = this.form.planIssuedVersion
                if (this.myUserClass === '管理') {
                  item.visible = true
                } else {
                  item.visible = false
                }
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      // 取出可执行的明细id
      for (let area of this.areas) {
        for (let row of area.rows) {
          if (
            menu.code === 'handleAssess' &&
            row.id > 0 &&
            row.pid <= 0 &&
            row.handleResult === '接收' &&
            row.assessResult === '' &&
            !this.cellIdList.includes(row.id) &&
            row.userCompany === this.myUserCompany
          ) {
            this.cellIdList.push(row.id)
          } else if (
            menu.code === 'handleAcceptOn' &&
            row.id > 0 &&
            row.pid <= 0 &&
            row.handleResult === '' &&
            !this.cellIdList.includes(row.id)
          ) {
            this.cellIdList.push(row.id)
          } else if (
            menu.code === 'handleAcceptOff' &&
            row.id > 0 &&
            row.pid <= 0 &&
            row.handleResult &&
            row.handleResult !== '' &&
            !this.cellIdList.includes(row.id)
          ) {
            this.cellIdList.push(row.id)
          } else if (
            menu.code === 'handleInvalidOn' &&
            row.id > 0 &&
            row.pid <= 0 &&
            row.handleResult !== '作废' &&
            !this.cellIdList.includes(row.id)
          ) {
            this.cellIdList.push(row.id)
          } else if (
            menu.code === 'handleInvalidOff' &&
            row.id > 0 &&
            row.pid <= 0 &&
            row.handleResult === '作废' &&
            !this.cellIdList.includes(row.id)
          ) {
            this.cellIdList.push(row.id)
          }
        }
      }
      if (this.cellIdList.length === 0) {
        this.$message.error('您没有选中需要您处理的明细!')
        return
      }
      if (menu.code === 'handleAssess') {
        this.$refs.AssessModal.formVisible = true
      } else if (menu.code === 'handleAcceptOn') {
        this.$refs.AcceptModal.formVisible = true
      } else if (menu.code === 'handleAcceptOff') {
        this.handleAcceptOff()
      } else if (menu.code === 'handleInvalidOn') {
        this.handleInvalid('on')
      } else if (menu.code === 'handleInvalidOff') {
        this.handleInvalid('off')
      }
    },
    // 双击明细时触发编辑
    cellDblclick({ column, row }) {
      if (column.property !== 'requirementDesc' && column.property !== 'suggestedSolutions') {
        return
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return
      }
      // 父节点不弹窗
      if (row.parentID < 0) {
        return
      }
      // 判断是否禁用 ==> 明细单位是自己或者有预计更新版本，或者有处理信息时进入模态窗为禁用
      if (
        (row['userCompany'] !== this.myUserCompany && !['管理', '运维'].includes(this.myUserClass)) ||
        this.form.planIssuedVersion ||
        (row['handleResult'] && row['handleResult'] !== '')
      ) {
        this.isDisabledToDetail = true
      } else {
        this.isDisabledToDetail = false
      }
      this.updateRow = row
      this.$refs.DetailUpdateModal.formVisible = true
    },
    // cell激活控制
    activeMethod({ column, row }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (
        row.parentID < 0 ||
        (row['userCompany'] !== this.myUserCompany && !['管理', '运维'].includes(this.myUserClass))
      ) {
        return false
      }
      this.$refs.xTable.setCellAreas([{ startRow: row, endRow: row, startColumn: column, endColumn: column }])
      // this.updateRow = row
      // this.$refs.DetailUpdateModal.formVisible = true
      return false
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!row.parentID) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return false
    },
    // 获取权限
    InitRight() {},
    // 获取明细数据
    async getBoth(id) {
      this.id = id
      const { data: res } = await this.$http.get('/Bugs/YKBug/both', {
        params: {
          id: id
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.form = res.data

      if (this.form.detailList.length > 0 || this.form.planIssuedVersion) {
        this.ifHasDetail = true
      } else {
        this.ifHasDetail = false
      }
      //#region  展开本公司登记记录
      // let cacheRow = null
      // for (let item of this.form.detailList) {
      //   if (item.pid === 0) {
      //     continue
      //   }
      //   if (item.userCompany === this.myUserCompany) {
      //     // pid = item.pid
      //     cacheRow = item
      //     break
      //   }
      // }
      //#endregion
      this.$nextTick(() => {
        // 如果为开发账号，则也全部展开
        // if (this.myUserClass === '客户' && this.$store.state.userInfo.userNum !== '开发') {
        //   if (cacheRow) {
        //     this.$refs.xTable.setTreeExpand(cacheRow, true)
        //   }
        // } else {
        // 3-15更改为全部展开
        this.$refs.xTable.setAllTreeExpand(true)
        // }
        this.$refs.FormRef.clearValidate()
        this.IfExistModify = false
      })
    },
    // 关窗口之前
    async beforeHideModal() {
      if (!(await this.tipsCloseModal())) {
        return new Error()
      }
    },
    // 关窗口
    async tipsCloseModal() {
      let ifClose = false
      if (this.IfExistModify) {
        await this.$confirm('您已做出修改，是否关闭窗口？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            ifClose = true
          })
          .catch(() => {})
      } else {
        ifClose = true
      }
      return ifClose
    },
    // 关闭窗口后
    closeModal() {
      // this.parentData['list']()
    },
    // 最大化事件
    zoomWindow(e) {
      if (e.type === 'max') {
        this.zoomHeightRatio = 1
      } else {
        this.zoomHeightRatio = 0.9
      }
    },
    // 初始化校验规则
    setFormVaild() {
      this.rules = {
        groupName: [
          { required: true, message: '请选择模块', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        vuePath: [
          { required: true, message: '请选择菜单', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      }
      this.validRules = {
        requirementDesc: [
          { required: true, message: '请输入需求描述', trigger: 'change' }
          // {
          //   min: 0,
          //   max: 128,
          //   message: '长度在 0 到 128 个字符',
          //   trigger: 'change'
          // }
        ],
        suggestedSolutions: [
          { required: true, message: '请输入建议解决方案', trigger: 'change' }
          // {
          //   min: 0,
          //   max: 128,
          //   message: '长度在 0 到 128 个字符',
          //   trigger: 'change'
          // }
        ]
      }
    },
    // detailList过滤父节点
    filterDetailList(detailList = []) {
      const list = []
      for (let item of detailList) {
        if (item.pid === 0) {
          list.push(item)
        }
      }
      return list
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.AllItems = []
      this.ComBoxItems.groupName = []
      const { data: res } = await this.$http.post(`/Bugs/YKBug/select?productionType=${this.$store.state.productType}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.ComBoxItems.AllItems = res.data
      if (this.updateId === 0) {
        this.groupNameChange()
      }
      // 过滤出模块下拉框
      for (let item of res.data) {
        if (!this.ComBoxItems.groupName.includes(item.groupName)) {
          this.ComBoxItems.groupName.push(item.groupName)
        }
      }
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 新增
    async add() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      form.detailList = this.filterDetailList(insertRecords)
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.post('/Bugs/YKBug/both', form)
      if (res.isSuccess) {
        this.id = res.data
        this.$message.success(this.messageConfig.save.success)
        this.parentData['list']()
        this.id = res.data
        this.$emit('updateModalType', '修改')
        this.getBoth(res.data)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update() {
      let form = { ...this.form }
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }
      form.detailList = this.filterDetailList(form.detailList) // 过滤父节点数据
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.put('/Bugs/YKBug/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        this.parentData['list']()
        this.getBoth(this.id)
        // this.formVisible = false
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 删除单据
    del() {
      if (this.onlyMyCompany) {
        this.$messagebox
          .confirm('确认删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            const { data: res } = await this.$http.delete('/Bugs/YKBug', {
              data: {
                id: this.id,
                idList: [],
                effectCondition: '',
                empower: []
              }
            })
            if (!res.isSuccess) {
              this.$message.error(res.errorMessage)
              return false
            }
            this.$message.success('删除成功!')
            this.parentData['list']()
            this.formVisible = false
          })
      } else {
        this.$message.error('删除失败, 此单据包含其他单位的数据!')
      }
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const tableData = []
      //#region 获取需要校验的行，排除父节点行
      for (let item of this.$refs.xTable.getTableData().fullData) {
        if (item.children) {
          for (let detailItem of item.children) {
            tableData.push(detailItem)
          }
        }
      }
      for (let item of this.$refs.xTable.getInsertRecords()) {
        if (item.parentID > 0) {
          tableData.push(item)
        }
      }
      //#endregion
      if (tableData.length > 0) {
        const errMap = await this.$refs.xTable.validate(tableData)
        if (errMap) {
          Object.values(errMap).forEach(errList => {
            errList.forEach(params => {
              let { row, columnIndex, rules } = params
              if (row.parentID > 0) {
                rules.forEach(() => {
                  this.errIndex.push({
                    _XID: row._XID,
                    columnIndex: columnIndex
                  })
                })
              }
            })
          })
          if (this.errIndex.length > 0) {
            flag = false
          }
        }
      } else if (tableData.length === 0) {
        this.$XModal.alert({
          message: this.messageConfig.blankDetail,
          status: 'warning'
        })
        return false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    }
  },
  computed: {
    tableHeight() {
      const titleHeight = 42.5
      const formHeight = 66
      const divider = this.$store.state.ykDivider
      const buttonHeight = 40
      const toolbarHeight = 52
      let height =
        Number(this.$store.state.clientHeight) * this.zoomHeightRatio -
        25 -
        titleHeight -
        formHeight -
        divider * 2 -
        buttonHeight -
        toolbarHeight
      return height + 'px'
    },
    onlyMyCompany() {
      let onlyMyCompany = true
      if (this.$refs.xTable.getTableData().fullData?.length > 0) {
        for (const item of this.$refs.xTable.getTableData().fullData) {
          if (item.userCompany !== this.myUserCompany) {
            onlyMyCompany = false
            break
          }
        }
      } else {
        onlyMyCompany = false
      }

      return onlyMyCompany
    }
  },
  watch: {
    'form': {
      handler() {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    },
    'form.groupName': {
      handler() {
        this.groupNameChange()
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.buttonContainer {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0 0 0;
  .fl;

  > button {
    padding: 0;
    width: 180px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}
#vxeDelete {
  color: red;
}
#vxeDeleteDisabled {
  color: #999;
}
</style>
